import { render, staticRenderFns } from "./DashboardEinstellung.vue?vue&type=template&id=0fa2d817"
import script from "./DashboardEinstellung.vue?vue&type=script&lang=js"
export * from "./DashboardEinstellung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports